const InputIds = {
    ['GeneralInformationNode']: {
        WorksheetTitle: 'WorksheetTitle',
        WorksheetStatus: 'WorksheetStatus',
        BookingYear: 'BookingYear',
        BookingPeriod: 'BookingPeriod'
    },
    ['BalanceInformationNode']: {
        BusinessId: 'BusinessId',
        InsuredPeriodStart: 'InsuredPeriodStart',
        InsuredPeriodEnd: 'InsuredPeriodEnd',
        UnderwritingYear: 'UnderwritingYear',
        Currency: 'Currency',
        DocumentSignedShare: 'DocumentSignedShare',
        SystemSignedShare: 'SystemSignedShare',
        SignedShareType: 'SignedShareType',
        DueDate: 'DueDate',
        AccountingPeriod: 'AccountingPeriod',
        AccountingYear: 'AccountingYear'
    },
    ['EntryCodeNode']: {
        Section: 'Section',
        AccountingClass: 'AccountingClass',
        HeadlineLoss: 'HeadlineLoss',
        EntryCodeValue: 'EntryCodeValue',
        EntryCodeShare: 'EntryCodeShare',
        EntryCodeSum: 'EntryCodeSum'
    }
} as const;

export default InputIds;
